export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const ON_SORTING_CHANGE = 'ON_SORTING_CHANGE';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART';
export const ADD_ONE_QUANTITY = 'ADD_ONE_QUANTITY';
export const REMOVE_ONE_QUANTITY = 'REMOVE_ONE_QUANTITY';
